import { useMemo } from 'react';
import { useResolveBucketsWithUtmByAssetCoordinatesQuery } from 'campaigns-lib/__generated__/chirp/com/hubspot/campaignsbucket/rpc/CampaignsBucketServiceFrontendRpc.hooks';
import { RESOLVE_BUCKETS_WITH_UTM_BY_ASSET_COORDINATES_QUERY_FIELD_NAME } from 'campaigns-lib/__generated__/chirp/com/hubspot/campaignsbucket/rpc/CampaignsBucketServiceFrontendRpc.dfc.new';
import { useCampaignsContext } from '../CampaignsProvider';
export const GET_ASSOCIATED_CAMPAIGNS_V2_FIELD_NAME = RESOLVE_BUCKETS_WITH_UTM_BY_ASSET_COORDINATES_QUERY_FIELD_NAME;
const formatResponse = results => {
  var _results$, _results$2;
  const utmCampaignGuid = (_results$ = results[0]) === null || _results$ === void 0 || (_results$ = _results$.utmCampaignGuids) === null || _results$ === void 0 ? void 0 : _results$[0];
  const campaignGuids = (((_results$2 = results[0]) === null || _results$2 === void 0 ? void 0 : _results$2.campaignBuckets) || []).map(cb => cb.guid).filter(g => g !== utmCampaignGuid);
  if (utmCampaignGuid) {
    campaignGuids.push(utmCampaignGuid);
  }
  return {
    campaignGuids,
    utmCampaignGuid
  };
};
export const useFetchAssociatedCampaignsV2 = ({
  objectId,
  objectTypeId,
  skip,
  onSuccess
}) => {
  const {
    setInitialCampaigns
  } = useCampaignsContext();
  const queryResult = useResolveBucketsWithUtmByAssetCoordinatesQuery({
    variables: {
      coordinates: [{
        objectTypeId,
        objectId: Number(objectId)
      }]
    },
    skip: !objectId || skip,
    onCompleted: data => {
      var _data$result$results;
      const results = (_data$result$results = data === null || data === void 0 ? void 0 : data.result.results) !== null && _data$result$results !== void 0 ? _data$result$results : [];
      const {
        campaignGuids,
        utmCampaignGuid
      } = formatResponse(results);
      setInitialCampaigns(campaignGuids.map(guid => ({
        campaignGuid: guid,
        objectId: objectId !== null && objectId !== void 0 ? objectId : null
      })));
      onSuccess === null || onSuccess === void 0 || onSuccess({
        campaignGuids,
        utmCampaignGuid
      });
    }
  });
  const data = useMemo(() => {
    var _queryResult$data$res, _queryResult$data;
    const results = (_queryResult$data$res = (_queryResult$data = queryResult.data) === null || _queryResult$data === void 0 ? void 0 : _queryResult$data.results) !== null && _queryResult$data$res !== void 0 ? _queryResult$data$res : [];
    return formatResponse(results);
  }, [queryResult.data]);
  return {
    data,
    loading: queryResult.loading,
    error: queryResult.error,
    refetch: queryResult.refetch
  };
};